import { Injectable } from '@angular/core';
 
@Injectable({
  providedIn: 'root'
})
export class ToggleThemeService {
  private themeLinkId = 'theme-link';
  private lightTheme = 'assets/themes/dx.fluent.light-scheme/dx.fluent.light-scheme.css';
  private darkTheme = 'assets/themes/dx.fluent.dark-scheme/dx.fluent.dark-scheme.css';
 
  private isDarkMode = false;
 
  constructor() {
    const savedTheme = localStorage.getItem('isDarkTheme');
    this.isDarkMode = savedTheme === 'true';
    this.applyTheme(this.isDarkMode);
  }
 
  toggleTheme(): void {
    this.isDarkMode = !this.isDarkMode;
    localStorage.setItem('isDarkTheme', this.isDarkMode.toString());
    this.applyTheme(this.isDarkMode);
  }
 
  applyTheme(isDark: boolean): void {
    // Set theme file (DevExtreme)
    const themeLink = document.getElementById(this.themeLinkId) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = isDark ? this.darkTheme : this.lightTheme;
    }
 
    // Apply body class for custom CSS variables
    document.body.classList.remove('light', 'dark');
    document.body.classList.add(isDark ? 'dark' : 'light');
  }
 
  get currentThemeIsDark(): boolean {
    return this.isDarkMode;
  }
}